import { SITE_URL } from "@/lib/founders/content";
import { localesForPath } from "./content";
import { LOCALE_META, localizedPath, type Locale } from "./locales";

export const localizedUrl = (locale: Locale, path: string): string => {
  const full = localizedPath(locale, path);
  return full === "/" ? `${SITE_URL}/` : `${SITE_URL}${full}`;
};

export type LanguageAlternate = { hrefLang: string; href: string };

export const languageAlternates = (path: string): LanguageAlternate[] | undefined => {
  const locales = localesForPath(path);
  if (!locales.length) return undefined;
  const english = localizedUrl("en", path);
  return [
    { hrefLang: "en", href: english },
    ...locales.map((locale) => ({
      hrefLang: LOCALE_META[locale].htmlLang,
      href: localizedUrl(locale, path),
    })),
    { hrefLang: "x-default", href: english },
  ];
};

export const localeSeoProps = (locale: Locale, path: string) => {
  const alternates = languageAlternates(path);
  if (locale === "en") return { languageAlternates: alternates };
  const canonical = localizedUrl(locale, path);
  return {
    languageAlternates: alternates,
    canonical,
    openGraph: { locale: LOCALE_META[locale].ogLocale, url: canonical },
  };
};
